import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../../BaseUrlConfigration/ApiConfig";
import toast from "react-hot-toast";

export const collectioncreateAction=createAsyncThunk(
    'collection/create',async(reqBody,thunkAPI)=>{
        try {
            const response = await Api.post('school/collection/create',reqBody)
            return response.data
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    })

    export const collectionEditAction=createAsyncThunk(
        'collection/edit',async(reqBody,thunkAPI)=>{
            try {
                const response = await Api.put('school/collection/edit',reqBody)
                return response.data
            } catch (error) {
                return thunkAPI.rejectWithValue(error.response.data);
            }
        })

    

    export const collectionShareAction=createAsyncThunk(
        'collection/share',async(reqBody,thunkAPI)=>{
            try {
                const response = await Api.post('school/collection/share',reqBody)
                return response.data
            } catch (error) {
                return thunkAPI.rejectWithValue(error.response.data);
            }
        })


        export const collectionShareWithPerticulerTeacherAction = createAsyncThunk(
            'collection/collectionShareWithPerticulerTeacher',async(reqBody,thunkAPI)=>{
                try {
                    const response = await Api.post('school/collection/share/teacher',reqBody)
                    return response.data
                } catch (error) {
                    return thunkAPI.rejectWithValue(error.response.data);
                }
            })
            

    export const collectionShareWithPerticulerStudentAction=createAsyncThunk(
        'collection/collectionShareWithPerticulerStudent',async(reqBody,thunkAPI)=>{
            try {
                const response = await Api.post('school/collection/share/student',reqBody)
                return response.data
            } catch (error) {
                return thunkAPI.rejectWithValue(error.response.data);
            }
        })


    export const collectionlistAction=createAsyncThunk(
        'collection/list',async(reqBody,thunkAPI)=>{
            try {
                const response = await Api.get(`school/collection/list?search=${reqBody?.searchValue}`)
               
                return response.data
            } catch (error) {
                return thunkAPI.rejectWithValue(error.response.data);
            }
        })

        export const allOwnerCollectionlistAction=createAsyncThunk(
            'collection/allOwnerColleclist',async(reqBody,thunkAPI)=>{
                try {
                    const response = await Api.get(`school/collection/fetch-all`)
                    return response.data
                } catch (error) {
                    return thunkAPI.rejectWithValue(error.response.data);
                }
            })



        export const collectionlistActionForSharedWithMe =createAsyncThunk(
            'collectionlistActionForSharedWithMe/list',async(reqBody,thunkAPI)=>{
                try {
                    const response = await Api.get(`school/collection/shared`)
                   
                    return response.data
                } catch (error) {
                    return thunkAPI.rejectWithValue(error.response.data);
                }
            })



            export const collectionDailyUsageAction=createAsyncThunk(
                'teacher/dailyUsage',async(reqBody,thunkAPI)=>{
                    try {
                        const response = await Api.get(`school/admin/active-hours?id=${reqBody.id}&startOfWeek=${reqBody?.date.startOfWeek}&endOfWeek=${reqBody?.date?.endOfWeek}`)
                       
                        return response.data  
                    } catch (error) {
                        return thunkAPI.rejectWithValue(error.response.data);
                    }
                })


        export const avatarAction=createAsyncThunk(
            'collection/avatar',async(reqBody,thunkAPI)=>{
                try {
                    const response = await Api.get(`school/collection/image`)
                   
                    return response.data
                } catch (error) {
                    return thunkAPI.rejectWithValue(error.response.data);
                }
            })
    

    export const collectiondeleteAction=createAsyncThunk(
        'collection/delete',async(reqBody,thunkAPI)=>{
            try {
                const response = await Api.delete(`school/collection/delete?id=${reqBody}`)
                
                return response.data
            } catch (error) {
                return thunkAPI.rejectWithValue(error.response.data);
            }
        })

        export const ClassCollectionDeleteAction=createAsyncThunk(
            'classcollection/delete',async(reqBody,thunkAPI)=>{
                try {
                    const response = await Api.post(`school/class/remove-collection` ,reqBody)
                    return response.data
                } catch (error) {
                    return thunkAPI.rejectWithValue(error.response.data);
                }
            })


        export const collectiondetailsAction=createAsyncThunk(
            'collection/details',async(reqBody,thunkAPI)=>{
                try {
                    const response = await Api.get(`school/collection/details?id=${reqBody}`)
                    
                    return response.data
                } catch (error) {
                    return thunkAPI.rejectWithValue(error.response.data);
                }
            })

        export const saveCollectionToSelf=createAsyncThunk(
            'collection/saveCollection',async(data,thunkAPI)=>{
                try {
                    const response = await Api.put(`school/collection/save-to-self?collectionId=${data?.collectionId}`)
                    toast.success(response.data.message)
                    return response.data
                } catch (error) {
                    toast.error(error.response.data.message)

                }
            })



            export const deleteSelectedVideosFromCollection=createAsyncThunk(
                'collection/videoDelete',async(reqBody,thunkAPI)=>{
                    try {
                        const response = await Api.post(`school/collection/remove-video` ,reqBody)
                        
                        return response.data
                    } catch (error) {
                        return thunkAPI.rejectWithValue(error.response.data);
                    }
                })

            export const resetCollectionAction = createAction('collection/reset');





                        
















                